module.exports = __webpack_public_path__ + "img/xiang02.8bce753b.png";